import 'vue';
import './helpers.mjs';
import './config.mjs';
import { b as registerComponent } from './plugins-ba5e2464.mjs';
import './CheckRadioMixin-f5b57344.mjs';
import { s as script } from './Checkbox-8670724c.mjs';
export { s as OCheckbox } from './Checkbox-8670724c.mjs';

var index = {
    install(app) {
        registerComponent(app, script);
    }
};

export default index;
